import { Box, makeStyles, Tab, Tabs, Typography } from "@material-ui/core";
import { useState } from "react";
import BaseDialog from "../components/BaseDialog";
import TabReserveFactor from "./TabReserveFactor";
import TabReserveParameter from "./TabReserveParameter";
import TabReserveState from "./TabReserveState";

const useStyle = makeStyles((theme) => ({
  text: {
    color: theme.palette.text.hint,
    marginBottom: 10,
  },
  hint: {
    color: theme.palette.text.hint,
  },
  tab: {
    color: theme.palette.text.hint,
    textTransform: "capitalize",
  },
}));

export const defaultConfig = { fullWidth: true, type: "number" };

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    "aria-controls": `wrapped-tabpanel-${index}`,
  };
}

export default function ReserveParameterDialog({ asset, open, onClose }) {
  const cls = useStyle();
  const [tab, setTab] = useState(0);

  const handleChange = (_, newValue) => {
    setTab(newValue);
  };

  return (
    <BaseDialog
      assetName={asset.symbol}
      assetIcon={asset.image}
      {...{ open, onClose }}
      maxWidth="sm"
      hiddenButton={true}
    >
      <Box>
        <Box>
          <Tabs value={tab} onChange={handleChange}>
            <Tab
              value={0}
              label={
                <Typography variant="subtitle2" fontWeight={tab === 0 ? "bold" : undefined} className={cls.tab}>
                  Reserve Parameter
                </Typography>
              }
              {...a11yProps(0)}
              disableRipple
            />
            <Tab
              value={1}
              label={
                <Typography variant="subtitle2" fontWeight={tab === 1 ? "bold" : undefined} className={cls.tab}>
                  Reserve Factor
                </Typography>
              }
              {...a11yProps(1)}
              disableRipple
            />
            <Tab
              value={2}
              label={
                <Typography variant="subtitle2" fontWeight={tab === 2 ? "bold" : undefined} className={cls.tab}>
                  Reserve State
                </Typography>
              }
              {...a11yProps(2)}
              disableRipple
            />
          </Tabs>
        </Box>
        <Box>
          <TabPanel value={tab} index={0}>
            <TabReserveParameter asset={asset} />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <TabReserveFactor asset={asset} />
          </TabPanel>
          <TabPanel value={tab} index={2}>
            <TabReserveState asset={asset} />
          </TabPanel>
        </Box>
      </Box>
    </BaseDialog>
  );
}
